<template>
  <div>
    <article v-for="production in productions" :key="production._id">
      <ProductionInfo :production="production" v-bind="params || {}" />
      <div>
        <slot v-bind:production="production" />
      </div>
    </article>
  </div>
</template>

<script>
import ProductionInfo from '@/components/ProductionInfo.vue'

export default {
  name: 'ProductionList',
  props: ['productions', 'params'],
  components: { ProductionInfo }
}
</script>

<style scoped>
article {
  padding: 1.5em 0 0.8em 0;
  background-image: linear-gradient(
    to right,
    rgba(0, 0, 0, 0.6) 0%,
    rgba(0, 0, 0, 0.6) 50%,
    transparent 50%,
    transparent 100%
  );
  background-position: left bottom;
  background-repeat: repeat-x;
  background-size: 6px 1px;
}
article:first-child {
  padding-top: 0;
}
</style>
